// ===========================LIVE URL==================
export const API_URL = 'https://api.uklogistic.com';
export const RETURN_URL = 'https://uklogistic.com/SuccessPayment'
export const RETURN_URL_BIKE = 'https://uklogistic.com/bikepaymentsuccess'
export const COURIER_USERNAME = 'LALJIMAHARAJENTERPRISE336456'
export const COURIER_PASSWORD = 'Lkwi5Zp54m'
export const IMAGE_URL = 'https://uklogistics.s3.ap-south-1.amazonaws.com'
export const RETURN_URL_Wallet = 'https://uklogistic.com/allOrders'

// ===================demo==========================

// export const API_URL = 'http://localhost:8000'
// export const RETURN_URL = 'http://localhost:3000/SuccessPayment'
// export const RETURN_URL_BIKE = 'http://localhost:3000/bikepaymentsuccess'
// export const RETURN_URL_Wallet = 'http://localhost:3000/allOrders'
// export const COURIER_USERNAME = 'LALJIMAHARAJENTERPRISE336456'
// export const COURIER_PASSWORD = 'Lkwi5Zp54m'
// export const IMAGE_URL = 'https://uklogistics.s3.ap-south-1.amazonaws.com'

